/**
 * An informational constant, containing the start of each route sections url.
 */
export const Routes = {
  bills: '/bill',
  amendments: '/amendment',
  committee: '/committee',
  committeeReport: '/committeeReport',
  congress: '/congress',
  congressionalRecord: '/congressional-record',
  houseCommunication: '/house-communication',
  member: '/member',
  nomination: '/nomination',
  summaries: '/summaries',
  treaty: '/treaty'
}
